import styled from 'styled-components';

export const HistoryContainerStyled = styled.div<{ $withPagination?: boolean }>`
  padding: 0 30px;
  height: ${(p) =>
    p.$withPagination ? 'calc(100vh - 224px)' : 'calc(100vh - 162px)'};
  overflow: auto;
  max-width: 998px;
`;
